import React, { Suspense } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/reducers/_index";

const TransEnglish = React.lazy(() => import("./en"));
const TransHungarian = React.lazy(() => import("./hu"));

const LegalTranslation = (props: any) => {
  const language: any = useSelector<RootState, any>(
    (state) => state.tempLanguage
  );

  return (
    <React.Fragment>
      {language === "en" ? (
        <Suspense fallback={<div style={{ height: "0px" }} />}>
          <TransEnglish setTermsTranslation={props.setTermsTranslation} />
        </Suspense>
      ) : null}
      {language === "hu" ? (
        <Suspense fallback={<div style={{ height: "0px" }} />}>
          <TransHungarian setTermsTranslation={props.setTermsTranslation} />
        </Suspense>
      ) : null}
    </React.Fragment>
  );
};

export default LegalTranslation;
